export enum PhoneNumberAssignmentAction {
    Assign = 'Assign',
    Unassign = 'Unassign'
}